/*
  Platmart Swatches zet standaard de eerste productfoto in het kleurstaaltje. Die foto is te ver
  uitgezoomd om een kleur aan af te lezen. Wij zetten er de detailfoto van het materiaal in: een
  strook uit de bovenkant van de close-up, die met background-size: cover het vakje vult. Zo zie je
  de echte kleur en de structuur, en dat leest een stuk rustiger dan een uitsnede van de sfeerfoto.

  De juiste foto per product staat in rt-swatch-data.js, samen met de hexcode en de volgorde:
    handle -> [hexcode, positie, foto-url]
  Rollenware heeft zelf alleen een foto van de rol; die leent de detailfoto van de meterversie in
  dezelfde kleur. Is er geen detailfoto, dan valt het staaltje terug op een vlak in de hexcode, en
  anders blijft staan wat de app zelf toont.

  De volgorde komt uit de kleurcode (501, 502, 503 ...).
*/
(function () {
  var data = window.rtSwatchData;
  if (!data) return;

  function handleVan(link) {
    var attr = link.getAttribute('data-handle');
    if (attr) return attr;
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function vulStaal(vlak, entry) {
    var kenmerk = entry[2] || entry[0];
    if (!kenmerk || vlak.getAttribute('data-rt-staal') === kenmerk) return;
    vlak.innerHTML = '';
    if (entry[2]) {
      vlak.style.backgroundImage = 'url("' + entry[2] + '")';
      vlak.style.backgroundSize = 'cover';
      vlak.style.backgroundPosition = 'center';
      if (entry[0]) vlak.style.backgroundColor = entry[0];
    } else {
      vlak.style.background = entry[0];
    }
    vlak.setAttribute('data-rt-staal', kenmerk);
  }

  function verwerk(container, linkSelector, kleurSelector) {
    var links = container.querySelectorAll(linkSelector);
    if (!links.length) return;

    var items = [];
    Array.prototype.forEach.call(links, function (link) {
      var entry = data[handleVan(link)];
      var vlak = link.querySelector(kleurSelector);
      if (entry && vlak) vulStaal(vlak, entry);
      items.push({ el: link, pos: entry ? entry[1] : 9999 });
    });

    if (container.getAttribute('data-rt-gesorteerd')) return;
    items.sort(function (a, b) { return a.pos - b.pos; });
    items.forEach(function (item) { container.appendChild(item.el); });
    container.setAttribute('data-rt-gesorteerd', '1');
  }

  function scan() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.pl-swatches__container'),
      function (c) { verwerk(c, 'a.pl-swatches__link', '.pl-swatches__color'); }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('.pl-swatches-collection__container'),
      function (c) { verwerk(c, 'a.pl-swatches-collection__link', '.pl-swatches-collection__color'); }
    );
  }

  scan();

  // De widget wordt door de app pas na het laden opgebouwd en bij een variantwissel opnieuw.
  if (window.MutationObserver) {
    var wachtend = null;
    var observer = new MutationObserver(function () {
      clearTimeout(wachtend);
      wachtend = setTimeout(scan, 60);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
